import {
  DEFAULT_CHAT_WINDOW_FONT_FAMILY,
  type VoiceConfig,
} from '@conversed/shared/src/central/types/webclient-config.type';
import React from 'react';
import type {
  BlockerConfig,
  ChatWindowState,
  GreetingOptions,
  MenuEntry,
  Scheme,
} from '../types/configs';

export type TConfigContext = {
  popupTimeout: number;
  welcomeMessage: string;
  waitingForTheBotResponseMessage: string;
  enableWaitingForBotResponseBlocker: boolean;
  notificationAIGeneratedAnswer: string;
  messageIcon: string;
  messagePlaceholder: string;
  menuTemplate: Array<MenuEntry>;
  showWelcomeAsFirstMessage: boolean;
  refParam?: string;
  revisionId?: string;
  useAttachment: boolean;
  language?: string;
  isSoundEnabled: boolean;
  defaultState: ChatWindowState;
  requireMicrosoftLogin: boolean;
  bubbleProps: {
    dim: number;
    icon: { open: string; closed: string } | string;
  };
  blockerConfig: BlockerConfig;
  headerConfig: {
    title: string;
    subtitle: string;
    logoType: string;
    logo: string;
    headerType: 'slim' | 'normal' | 'noimage';
  };
  scheme: Scheme;
  greeting: {
    message: string;
    title: string;
    subtitle: string;
    messageIcon: string;
    avatarType: string;
    avatarPath: string;
    headerType: string;
    showCloseButton: boolean;
  } & GreetingOptions;
  botId: string;
  configId: string;
  fonts: {
    chatWindow: string;
  };
  voice?: VoiceConfig;
  useStreamingResponse: boolean;
};

const contextDefault: TConfigContext = {
  popupTimeout: 0,
  welcomeMessage: '',
  waitingForTheBotResponseMessage: '',
  enableWaitingForBotResponseBlocker: false,
  notificationAIGeneratedAnswer: '',
  messageIcon: '',
  messagePlaceholder: '',
  menuTemplate: [],
  refParam: '',
  useAttachment: false,
  language: '',
  isSoundEnabled: false,
  showWelcomeAsFirstMessage: true,
  defaultState: 'closed',
  requireMicrosoftLogin: false,
  bubbleProps: {
    dim: 0,
    icon: '',
  },
  blockerConfig: {
    text: 'Updating conversation in another tab',
    buttonText: 'Continue here',
  },
  headerConfig: {
    title: '',
    subtitle: '',
    logoType: '',
    logo: '',
    headerType: 'normal',
  },
  scheme: {
    header: {
      headerColor: '',
      headerSubtitleColor: '',
      headerTitleColor: '',
      windowColor: '',
      messageBarColor: '',
    },
    greeting: {
      backgroundColor: '',
      buttonColor: '',
      buttonTextColor: '',
      subtitleColor: '',
      titleColor: '',
    },
    message: {
      buttonBackgroundColor: '',
      buttonEdgeColor: '',
      buttonHoverColor: '',
      buttonTextColor: '',
      carouselBackgroundColor: '',
      carouselButtonColor: '',
      carouselButtonTextColor: '',
      carouselTextColor: '',
      messageBubbleColor: '',
      messageBubbleTextColor: '',
      personalMessageBubbleColor: '',
      personalMessageBubbleTextColor: '',
      submitButtonColor: '',
      notificationAIGeneratedAnswerTextColor: '',
      streamingIndicatorColor: '',
      urlClickColor: '',
      urlColor: '',
      urlHoverColor: '',
      urlTextDecoration: 'underline',
    },
  },
  greeting: {
    message: '',
    title: '',
    subtitle: '',
    messageIcon: '',
    avatarType: '',
    avatarPath: '',
    headerType: '',
    showCloseButton: false,
    buttonText: '',
    allowLaterButton: true,
  },
  botId: '',
  configId: '',
  fonts: {
    chatWindow: DEFAULT_CHAT_WINDOW_FONT_FAMILY,
  },
  useStreamingResponse: false,
};

export const ConfigContext =
  React.createContext<TConfigContext>(contextDefault);
export const ConfigProvider = ConfigContext.Provider;
